module.exports = __webpack_public_path__ + "static/media/sense4010.6bbd9c91.jpg";